// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1zZjD","bigColWidth":"Table_bigColWidth__14XNo","biggerColWidth":"Table_biggerColWidth__1Jygq","row":"Table_row__2RpQd","col":"Table_col__3RYlP"};